import moment from 'moment';

// Reorder Upcoming Appointments where future appointments are listed first
// in ascending order followed by appointments prior to the current Date and time
// in descending order
export const reorderUpcomingAppointments = (upcomingAppointments: Array<any>) => {
  // now should be a little in the past as not to instantly hide an active appointment
  const now = moment().subtract(30, 'minute');
  if (upcomingAppointments.length) {
    upcomingAppointments.sort((aptA, aptB) => {
      // if both in the future, return the soonest appointment date
      if (
        moment(aptA.appointment_date_at_clinic_tz) > now &&
        moment(aptB.appointment_date_at_clinic_tz) > now
      ) {
        return (
          moment(aptA.appointment_date_at_clinic_tz).valueOf() -
          moment(aptB.appointment_date_at_clinic_tz).valueOf()
        );
      }
      // if a in future, return A on top
      if (moment(aptA.appointment_date_at_clinic_tz) > now) {
        return -1;
      }
      // if B in future, return B on top
      if (moment(aptB.appointment_date_at_clinic_tz) > now) {
        return 1;
      }
      // otherwise, sort in apt_date desc order
      return (
        moment(aptB.appointment_date_at_clinic_tz).valueOf() -
        moment(aptA.appointment_date_at_clinic_tz).valueOf()
      );
    });
  }

  return upcomingAppointments;
};

// This is a simple and conservative map which matches insurance profile names to insurance types.
const insuranceProfileSearchResult: { [key: string]: string } = {
  tricare: 'tricare',
  triwest: 'triwest',
  aetna: 'aetna',
  'blue cross': 'blue_cross_blue_shield',
  cigna: 'cigna',
  'united healthcare': 'united_healthcare',
  anthem: 'anthem',
  humana: 'humana',
};

/**
 * This function will attempt to match the insurance profile name to the insurance type.
 * If there is no match, or there are multiple matches, it will return undefined.
 *
 * @param input insurance profile name
 * @returns insurance type
 */
export function matchInsuranceProfileToInsuranceType(input: string): string | undefined {
  if (!input) {
    return undefined;
  }

  let matches: string[] = [];
  for (const key in insuranceProfileSearchResult) {
    if (input.toLowerCase().includes(key)) {
      matches.push(insuranceProfileSearchResult[key]);
    }
  }
  if (matches.length === 1) {
    return matches[0];
  }

  // Anthem and Blue Cross are the same insurance company - and some cards are "Anthem Blue Cross", so we'll just return blue cross.
  if (
    matches.length === 2 &&
    matches.includes('anthem') &&
    matches.includes('blueCrossBlueShield')
  ) {
    return 'blueCrossBlueShield';
  }

  return undefined;
}
